// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"c9817ccf","76":"1018fde4","222":"5e8a5d29","328":"b3fd6f55","361":"57626215","403":"43a60f5c","958":"31d6cfe0"}[chunkId] + ".chunk.css";
};